import { Link } from 'react-router-dom';
import heroImage from '@/assets/landing-hero-trading.png';
import './Landing.css';

const exchangeNames = ['OKX', 'Bybit', 'Binance', 'Bitget', 'Gateio', 'Hyperliquid'];

const featureCards = [
  {
    kicker: 'Market Radar',
    title: '跨所价差与资金费率雷达',
    text: '把机会榜、资金费率、mid 偏移和 K 线筛选集中在一个市场工作台里，快速定位值得进入交易页的标的。',
  },
  {
    kicker: 'Trading Desk',
    title: '图表、指令和仓位同屏',
    text: '交易页把实时价差、开关仓阈值、手动下单、在途任务和 position group 放在同一上下文，减少跳转误操作。',
  },
  {
    kicker: 'Portfolio Control',
    title: '账户盈亏与风险归因',
    text: '账户面板追踪权益、持仓名义价值、PnL、资金费和交易所分布，帮助判断收益来自价差还是成本结构。',
  },
  {
    kicker: 'Secure Setup',
    title: '交易所 API 与杠杆风控',
    text: '用户配置页集中管理 API Key、产品类型和按交易所杠杆上限，默认围绕只交易、不可提现的连接方式设计。',
  },
];

const workflowSteps = [
  ['01', '连接交易所', '配置 API Key、Secret 和可选 Passphrase，保存后由交易服务初始化私网客户端。'],
  ['02', '扫描机会', '在市场页筛选价差、资金费和波动结构，进入最适合的套利组合。'],
  ['03', '执行与监控', '在交易页创建开仓/关仓指令，持续观察任务、成交记录和仓位分组。'],
];

export function Landing() {
  return (
    <main className="landing-page">
      <nav className="landing-nav" aria-label="Landing navigation">
        <Link to="/landing" className="landing-brand">
          <span className="landing-brand-mark">A</span>
          <span>ArbX</span>
        </Link>
        <div className="landing-nav-links">
          <a href="#features">功能</a>
          <a href="#workflow">流程</a>
          <a href="#security">安全</a>
        </div>
        <div className="landing-nav-actions">
          <Link to="/login" className="landing-link-button">
            登录
          </Link>
          <Link to="/trading" className="landing-primary-button">
            开始使用
          </Link>
        </div>
      </nav>

      <section className="landing-hero">
        <div className="landing-hero-copy">
          <p className="landing-eyebrow">Crypto arbitrage control center</p>
          <h1>ArbX</h1>
          <p className="landing-hero-lead">
            面向专业交易者的多交易所套利工作台。把市场扫描、实时价差图表、手动交易、仓位风控和账户归因连接成一条清晰的执行链路。
          </p>
          <div className="landing-hero-actions">
            <Link to="/register" className="landing-primary-button large">
              创建账户
            </Link>
            <Link to="/trading" className="landing-secondary-button large">
              进入工作台
            </Link>
          </div>
          <div className="landing-trust-row" aria-label="Platform highlights">
            <span>多交易所</span>
            <span>实时风控</span>
            <span>持仓归因</span>
          </div>
        </div>
        <div className="landing-hero-visual">
          <img src={heroImage} alt="ArbX trading dashboard preview" />
          <div className="landing-hero-metric metric-a">
            <span>Net funding</span>
            <strong>+0.184%</strong>
          </div>
          <div className="landing-hero-metric metric-b">
            <span>Open spread</span>
            <strong>0.62%</strong>
          </div>
        </div>
      </section>

      <section className="landing-strip" aria-label="Supported exchanges">
        {exchangeNames.map((name) => (
          <span key={name}>{name}</span>
        ))}
      </section>

      <section id="features" className="landing-section">
        <div className="landing-section-head">
          <p className="landing-eyebrow">Product modules</p>
          <h2>从发现机会到管理风险，一个前端闭环</h2>
          <p>参考成熟交易机器人平台的“统一交易终端 + 组合管理 + 安全连接”思路，但聚焦你的套利执行场景。</p>
        </div>
        <div className="landing-feature-grid">
          {featureCards.map((card) => (
            <article key={card.title} className="landing-feature-card">
              <span>{card.kicker}</span>
              <h3>{card.title}</h3>
              <p>{card.text}</p>
            </article>
          ))}
        </div>
      </section>

      <section id="workflow" className="landing-workflow">
        <div className="landing-section-head">
          <p className="landing-eyebrow">Launch workflow</p>
          <h2>三步进入交易状态</h2>
        </div>
        <div className="landing-workflow-grid">
          {workflowSteps.map(([step, title, text]) => (
            <article key={step} className="landing-workflow-card">
              <strong>{step}</strong>
              <h3>{title}</h3>
              <p>{text}</p>
            </article>
          ))}
        </div>
      </section>

      <section id="security" className="landing-security">
        <div>
          <p className="landing-eyebrow">Risk first</p>
          <h2>发布前就把安全和可控性摆在台面上</h2>
        </div>
        <div className="landing-security-list">
          <p>密钥不完整回显，交易所连接和用户登录分层管理。</p>
          <p>按交易所设置最大杠杆，超过账户权益倍数后拒绝开仓。</p>
          <p>持仓、指令、在途任务和成交记录集中展示，便于回溯。</p>
        </div>
      </section>

      <section className="landing-cta">
        <h2>准备把套利工作台交给真实用户了吗？</h2>
        <p>先完成交易所配置，再从市场页进入交易台。系统会优先加载当前最大仓位对应的图表上下文。</p>
        <Link to="/register" className="landing-primary-button large">
          立即开始
        </Link>
      </section>
    </main>
  );
}
